import { Pipe, PipeTransform } from '@angular/core';
import { UnitType } from '../models/unit.model';
import { kilometersPerHourToMilesPerHour } from '../helpers/kilometers-per-hours-to-miles-per-hour.helpers';

@Pipe({
  name: 'speed',
})
export class SpeedPipe implements PipeTransform {
  transform(
    kmH: number,
    unit: UnitType,
    output: 'value' | 'unit' | 'both',
    rounded: number = 1,
  ): string {
    const raw: number = unit === 'imperial' ? kilometersPerHourToMilesPerHour(kmH) : kmH;
    let value: string = parseFloat(raw.toFixed(rounded)).toString();
    let unitStr = unit === 'imperial' ? 'mph' : 'km/h';

    switch (output) {
      case 'value':
        return `${value}`;
      case 'unit':
        return unitStr;
      case 'both':
        return `${value} ${unitStr}`;
    }
  }
}
